/** Painting without rebuilding what did not change (ported from the prototype: stops the screen flicker on every tap). */
type Raw = HTMLElement & { _raw?: string[] | null; _h?: string };

export function setH(el: HTMLElement | null, html: string): void {
  const e = el as Raw | null;
  if (e && e._h !== html) { e.innerHTML = html; e._h = html; }
}

function patch(par: HTMLElement, html: string, off = 0): void {
  const p = par as Raw;
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  [...tmp.childNodes].forEach((n) => { if (n.nodeType === 3 && !(n as Text).data.trim()) tmp.removeChild(n); });
  const nk = [...tmp.children] as HTMLElement[], raw = nk.map((e) => e.outerHTML), old = p._raw;
  if (!old || p.children.length !== off + old.length || p.childNodes.length !== p.children.length) {
    while (p.children.length > off) p.removeChild(p.lastElementChild!);
    nk.forEach((e) => p.appendChild(e));
    p._raw = raw;
    return;
  }
  nk.forEach((e, i) => {
    if (i < old.length) { if (old[i] !== raw[i]) p.replaceChild(e, p.children[off + i]!); } else p.appendChild(e);
  });
  while (p.children.length > off + nk.length) p.removeChild(p.lastElementChild!);
  p._raw = raw;
}

let HOST = '';
export function paintApp(sc: HTMLElement, need: boolean, min: boolean, body: string): void {
  const s = sc as Raw;
  if (!need) {
    if (HOST !== 'plain') { sc.innerHTML = ''; s._raw = null; HOST = 'plain'; }
    patch(sc, body, 0);
    return;
  }
  let gap = sc.querySelector<HTMLElement>(':scope>.mapgap'), sh = sc.querySelector<HTMLElement>(':scope>.sheetc');
  if (HOST !== 'map' || !gap || !sh) {
    sc.innerHTML = '<div class="mapgap"></div><div class="sheetc"><button class="grab" type="button" data-act="sheet"><i></i><span></span></button></div>';
    gap = sc.querySelector<HTMLElement>('.mapgap')!; sh = sc.querySelector<HTMLElement>('.sheetc')!;
    (sh as Raw)._raw = null; HOST = 'map';
  }
  const gh = min ? '100%' : '300px';
  if (gap.style.height !== gh) gap.style.height = gh;
  const cl = 'sheetc' + (min ? ' mn' : '');
  if (sh.className !== cl) sh.className = cl;
  const st = min ? '' : 'min-height:calc(100% - 300px)';
  if ((sh.getAttribute('style') ?? '') !== st) sh.setAttribute('style', st);
  const sp = sh.querySelector('.grab span')!, tx = min ? 'Show panel' : 'Hide panel, see full map';
  if (sp.textContent !== tx) sp.textContent = tx;
  patch(sh, min ? '' : body, 1);
}
